<template>
  <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2">
    <label :for="fieldPath" class="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
      {{ fieldLabel }}
    </label>
    <div class="mt-2 sm:col-span-2 sm:mt-0">
      <input
        data-1p-ignore
        :value="formatted"
        :disabled="enabled === false"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
        v-bind="fieldAttrs"
        type="text"
        :name="fieldPath"
        :id="fieldPath"
        class="block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 sm:max-w-xs sm:text-sm/6
               bg-white text-gray-900 outline-gray-300
               focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600
               invalid:outline-red-600 invalid:focus:outline-red-600
               disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
      />
      <p v-if="errors[fieldPath]" class="text-sm text-red-600">{{ errors[fieldPath] }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from "vue";

const { appContext } = getCurrentInstance();
const props = defineProps(["modelValue", "fieldPath", "fieldAttrs", "fieldLabel", "errors", "enabled"]);
const emit = defineEmits(["update:modelValue"]);
const isFocused = ref(false);
const formatMoney = appContext.config.globalProperties.$formatMoney;

const formatted = computed(() => {
  if (isFocused.value) {
    return props.modelValue != null ? props.modelValue : "";
  }
  return props.modelValue != null ? formatMoney(props.modelValue) : "0 €";
});

function onInput(event) {
  const raw = event.target.value.trim();
  if (raw === "") {
    emit("update:modelValue", null);
    return;
  }
  const numeric = parseFloat(raw.replace(/[^\d,.-]/g, "").replace(",", "."));
  emit("update:modelValue", isNaN(numeric) ? null : numeric);
}

function onBlur() {
  isFocused.value = false;
}

function onFocus() {
  isFocused.value = true;
}

</script>
